module.exports = __webpack_public_path__ + "img/left-arrow.ec6aa876.svg";